// Evite un bug JS
import 'regenerator-runtime/runtime'

// Menu Burger
import './inc/menu'

// Composants
import './inc/composant'

//Slider
import './inc/splide'

// Scroll
import './inc/scroll';

// Chargement lazydes images // Il faut ajouter lazyload en class aux images
// https://github.com/aFarkas/lazysizes/blob/gh-pages/README.md
import './vendor/lazysizes'

